interface rgbaColor{
	r: number,
	g: number,
	b: number,
	a: number
}

export function randomColor(): rgbaColor{
	return {
		r: Math.round(Math.random()*255),
		g: Math.round(Math.random()*255),
		b: Math.round(Math.random()*255),
		a: Math.random()
	};
}

export function grayColor(
	level: number=0,
	alpha?: number
): rgbaColor{
	if (!alpha){
		alpha = Math.random();
	}
	return {
		r: level,
		g: level,
		b: level,
		a: alpha
	}
}

export function getStarColor(opts={
	randomEvery: 3,
	randomGrays: false,
	randomAlpha: false,
	invert: true
}): rgbaColor{
	let {
		randomEvery,
		invert,
		randomGrays,
		randomAlpha
	} = opts;

	if (randomEvery){
		if (Math.random() < (1/randomEvery)){
			return randomColor();
		}
	}

	let alpha = randomAlpha ? Math.random() : 1;

	if (invert){
		return randomGrays
			? grayColor(Math.floor(Math.random() * 255))
			: {r: 0, g: 0, b: 0, a: alpha};
	}

	return {
		r: 255,
		g: 255,
		b: 255,
		a: alpha
	};
}